import iHttp from '../http';
import iStorage from '../storage';
import configuration from './configuration';
import { message as $Message } from 'ant-design-vue';
import LoadingBar from '@/components/loading-bar/index';

let axios = new iHttp({
    baseURL: configuration.gateway,
    alert: function (message) {
        $Message({ message: message })
    },
    block: function () {
        LoadingBar.start();
    },
    unblock: function () {
        LoadingBar.finish();
    },
    handle401: function () {
        
    }
}).api;

const getLoginUrl = function() {
    return new Promise(function(resolve, reject) {
        let params = {
            "collection": "cfg-portal-login-conf",
            "useCaching": true,
            "cachingKey": "",
            "filter": {
                "hostname": window.location.hostname // window.location.hostname //'supplier-dev.smartmice.cn'
            },
            "projection": {
                "loginUrl": 1
            }
        }
        axios.post("/api/tpm/cfg/getsettings", params).then(response => {
            if (response.success) {
                iStorage.set('loginUrl', response.content.loginUrl);
                resolve(response)
                // simulatorBus.openiaccount();
            } else {
                reject(response)
            }
        })
    })
}
export default getLoginUrl;
